// Styles
import '../scss/order.scss';

// Scripts
import { offer } from '@shop/frontend/dist/desktop/order-full-form';
import './custom/social-proof.js';

jQuery(function () {
  offer.getState(function (data) {
    const cmp = data.query.cmp;
    if (cmp === 'false') {
      $('.cmp-show').show();
    }

    let savePrice = data.products[2].templates.save;
    $('.save-price-hard').html('$' + savePrice.split('.')[0]);
  });

  let shippingCheck = $('#shipping_plus');
  function checkProduct() {
    if ($('.product1').hasClass('active') || $('.product2').hasClass('active')) {
      shippingCheck.prop('disabled', true);
      shippingCheck.prop('checked', false);
      $('.cont').addClass('noHover');
    } else {
      shippingCheck.prop('disabled', false);
      shippingCheck.prop('checked', true);
      $('.cont').removeClass('noHover');
    }
  }
  checkProduct();

  $('.product').on('click', function () {
    $('.product').removeClass('active');
    $(this).addClass('active');
    checkProduct();
  });
});
